<div class="qira-dialog">

  <div class="qira-dialog__header">
    <div class="qira-dialog__title-row">
      <mat-icon class="qira-dialog__icon">support_agent</mat-icon>
      <h2 class="qira-dialog__title">Contact Us</h2>
    </div>
    <button mat-icon-button class="qira-dialog__close" (click)="onCancel()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="qira-dialog__content">
    <form [formGroup]="form">
      <div class="qira-field">
        <label class="qira-field__label">Message</label>
        <textarea
          class="qira-field__textarea"
          formControlName="message"
          rows="6"
          maxlength="2000"
          placeholder="Describe your issue or question…">
        </textarea>
        <span class="qira-field__hint">{{ form.get('message')?.value?.length || 0 }} / 2000</span>
      </div>
    </form>
  </mat-dialog-content>

  <div class="qira-dialog__actions">
    <button mat-stroked-button class="qira-dialog__cancel" (click)="onCancel()">Cancel</button>
    <button mat-flat-button color="primary" class="qira-dialog__send" (click)="onSend()" [disabled]="form.invalid">
      <mat-icon>send</mat-icon>
      Send
    </button>
  </div>

</div>
